import axiosInstance from './axiosConfig';


// Interactive sales map getting here
export const interactiveSalesMap = async ({ formattedEnd , formattedStart }) => {
  const response = await axiosInstance.get(`/interactive_sales_maps?start_date=${formattedStart}&end_date=${formattedEnd}`);
  return response.data;
};